import { ContextData } from '@bioconnect-ui/file-service';

export enum ResourceRole {
  EQUIPMENT = 'Equipment',
  SUPPLIES = 'Supplies',
  SOFTWARE = 'Software',
}

export interface ResourceCategory {
  id?: number;
  name: string;
  description?: string;
  role: ResourceRole;
}

export interface Resource {
  id?: number;
  name: string;
  role?: ResourceRole;
  category?: ResourceCategory;
  category_id?: number;
  manufacturer?: string;
  manufacturer_address?: string;
  model_id?: string;
  rrid?: string;
  context_data?: ContextData[];
}
